import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import TextScenarioComponent from "../../components/dashboard/knowledge-bases-create/scenario/text-scenario.component";
import VideoScenarioComponent from "../../components/dashboard/knowledge-bases-create/video-scenario/video-scenario.component";

const McBotFaceEditor = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !searchParams.has("type") ||
      !["text-scenario", "video-scenario"].includes(
        searchParams.get("type") as string
      )
    ) {
      toast.error("Selected bot type was not recognized as McBotFace instance");

      navigate("../");
    }
  }, [searchParams]);

  const typeMapper: { [key: string]: React.ReactNode } = {
    "text-scenario": <TextScenarioComponent />,
    "video-scenario": <VideoScenarioComponent />
  };

  return (
    <React.Fragment>
      {typeMapper[searchParams.get("type") as string]}
    </React.Fragment>
  );
};

export default McBotFaceEditor;
